import React from 'react';
import { useSelector } from 'react-redux';

const PhaseDiagram = (props) => {
  const index = props.index;
  const phases = useSelector(state => state.entities.pm.phases);
  const selectedPhase = phases[index];
  const imageName = `/phase-${selectedPhase}.PNG`;

  return (
    <div style={{
      padding: '10px',
      display: 'none'
    }}>
      <h3>{`Phase ${index}`}</h3>
      <img style={{
        width: '100%',
        height: '80%'
      }} src={imageName}/>
    </div>
  );
};
export default PhaseDiagram;

